import { useEffect, useRef } from "react";
import { DownloadedImage } from "../../../models/DownloadedImage";
import { SpanHighlightObject } from "../../../models/HighlightObject";
import { DownloadedImageStore } from "../../../stores/impl/DownloadedImageStore";
import { useAsync } from "../useAsync";

export { useImageWithSpans };

// returns value, and method to trigger
function useImageWithSpans(
  imageUrl: string | undefined,
  _inclSpans: boolean,
  _spans: SpanHighlightObject[],
  pageDimensions?: {
    width?: number;
    height?: number;
  },
): [DownloadedImage | undefined, boolean] {
  const lastArguments = useRef({
    imageUrl,
    _inclSpans,
    _spans,
    pageDimensions,
  });

  DownloadedImageStore.setup();

  const [value, trigger, loading, override] = useAsync(
    async (
      url: string,
      inclSpans: boolean,
      spans,
      pageDimensions?: {
        width: number;
        height: number;
      },
    ) => {
      // TODO: cache
      return DownloadedImageStore.getWithRenderedSpans(
        url,
        inclSpans,
        spans,
        pageDimensions,
      );
      // }
    },
    undefined as DownloadedImage | undefined,
  );

  useEffect(() => {
    if (!imageUrl) {
      return override(undefined);
    }

    // There is a race condition where
    // This runs with page change before spans have updated
    // Then old spans get rendered
    // Store the last inputs for comparison
    if (
      imageUrl !== lastArguments.current.imageUrl &&
      _spans.length &&
      _spans === lastArguments.current._spans
    ) {
      // page has changed
      // but spans are the same
      // requires spans to have length as if spans
      // are set to not display
      // will always have same object []
      return;
    }

    lastArguments.current = {
      imageUrl,
      _inclSpans,
      _spans,
      pageDimensions,
    };

    trigger(imageUrl, _inclSpans, _spans, pageDimensions);
  }, [_spans, _inclSpans, imageUrl]);

  return [value, loading];
}
